module.exports = __webpack_public_path__ + "img/freelancer-hiring-4.fb581158.png";